import Transforms from './transforms'

const endpoints = {
    me: {
        path: '/admin/users/me',
        transform: Transforms.me,
    },
}

export default {
    name: 'users',
    endpoints,
}
